import {
    createHandlerChainRunnerOptionalParameter,
    Handler,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { patchRetailModeSettings, PatchRetailModeSettingsApiParameter } from "@store/Services/RetailModeService";
import setRetailModeStatus from "@store/Store/Data/RetailMode/Handlers/SetRetailModeStatus";
import { mapEditingToRetailModeSettings } from "@store/Store/Data/RetailModeSettings/RetailModeSettingsSelector";
import { StoreHandlerProps } from "@store/Store/HandlerCreator";
import { RetailModeSettingsModel } from "@store/Types/RetailModeSettings";

type Parameter = {};
type Props = StoreHandlerProps & {
    settings: RetailModeSettingsModel;
    apiParameter: PatchRetailModeSettingsApiParameter;
    apiResult: RetailModeSettingsModel;
};

type HandlerType = Handler<Parameter, Props>;

export const DispatchBeginUpdateSettings: HandlerType = props => {
    props.dispatch({
        type: "Store/Data/RetailModeSettings/BeginUpdateSettings",
    });
};

export const GetCurrentSettings: HandlerType = props => {
    const settings = props.getState().store.data.retailModeSettings.editingRetailMode;
    if (!settings) {
        throw new Error("There was no settings when we are trying to save them");
    }
    props.settings = mapEditingToRetailModeSettings(settings);
};

export const ApplyParameters: HandlerType = props => {
    props.apiParameter = {
        settings: props.settings,
    };
};

export const SaveRetailModeSettings: HandlerType = async props => {
    props.apiResult = await patchRetailModeSettings(props.apiParameter);
};

export const DispatchCompleteUpdateSettings: HandlerType = props => {
    props.dispatch({
        type: "Store/Data/RetailModeSettings/CompleteLoadSettings",
        settings: props.apiResult,
    });
};

export const SetRetailModeStatus: HandlerType = props => {
    props.dispatch(setRetailModeStatus(props.apiResult));
};

export const chain = [
    DispatchBeginUpdateSettings,
    GetCurrentSettings,
    ApplyParameters,
    SaveRetailModeSettings,
    DispatchCompleteUpdateSettings,
    SetRetailModeStatus,
];

const PatchRetailModeSettings = createHandlerChainRunnerOptionalParameter(chain, {}, "PatchRetailModeSettings");
export default PatchRetailModeSettings;
